import React from 'react';
import DataGrid from '@dataGrid';
import DollyGridConfig from './GridConfig';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import { withFeatureFlags } from '../../../../../userProfile/featureFlagsContext';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import styles from '../styles';
import StatusBar from '@dataGrid/components/StatusBar';
import { getFilteredData } from '../../../../common/filterUtilities';
import { isEqual } from 'lodash/lang';
import Events from '../../../../../utilities/EventEmitter';
import appConstants from '../../../../../appConstants';

class DollyGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new DollyGridConfig({
      showTrailerScacColumn: this.props.showTrailerScac,
      showTrailerScacValue: this.props.featureFlags.isFeatureEnabled(
        appConstants.features.ShowTrailerScac
      ),
      userConfig: this.props.userData.userProfile?.columnPref
    });
    this.state = {
      quickFilter: ''
    };
  }
  componentDidMount() {
    this.props.glEventHub.on('UpdateDollyQuickFilter', this.updatedQuickFilter);
    Events.on('AssetDollyUpdate', this.updateDollyList);
    Events.on('AssetUpdateDefects', this.updateDollyDefects);
  }

  componentWillUnmount() {
    this.props.glEventHub.off('UpdateDollyQuickFilter', this.updatedQuickFilter);
    Events.off('AssetDollyUpdate', this.updateDollyList);
    Events.off('AssetUpdateDefects', this.updateDollyDefects);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedAssets, prevProps.selectedAssets)) {
      this.updateSelection();
    }
  }

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + ' Dolly',
        filterCondition: ''
      }
    ];
  };

  getFilteredDolly = () => {
    if (!this.state.quickFilter) {
      return this.props.dollyList || [];
    }
    return getFilteredData(this.props.dollyList, this.state.quickFilter);
  };

  onSelectionChanged = () => {
    if (this.props.assetSelectedOnGrid && this.gridApi) {
      const selectedDolly = this.gridApi.getSelectedRows().map((dolly) => dolly);
      this.props.assetSelectedOnGrid(selectedDolly);
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.setGridApi(api);
  };

  updatedQuickFilter = (quickFilter) => {
    this.setState({
      quickFilter
    });
  };

  updateSelection = () => {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (this.props.selectedAssets?.includes(node.data.dollyId)) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: 'selectionChanged',
        api: this.gridApi
      });
    }
  };

  updateDollyList = (data) => {
    this.props.updateEquipmentList({
      equipmentNumber: data?.dollyNumber,
      equipmentId: data?.dollyId,
      success: data.success || false
    });
  };

  updateDollyDefects = ({ dolly }) => {
    if (dolly) {
      this.updateDollyList({ ...dolly, success: true });
    }
  };

  render() {
    const dollyList = this.getFilteredDolly();
    const { classes, searchText, showErrorMessage, isAssetUpdateFormOpen } = this.props;
    return (
      <div className={classes.dataGrid}>
        <DataGrid
          onGridReady={this.onGridReady}
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={dollyList}
          onRowDataUpdated={this.updateSelection}
          onSelectionChanged={this.onSelectionChanged}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.dollyId}
          panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
          isExternalFilterPresent={() => false}
          quickFilterText={searchText}
          showErrorMessage={showErrorMessage}
          suppressRowClickSelection={isAssetUpdateFormOpen}
        />
      </div>
    );
  }
}
export default compose(withUserProfile, withFeatureFlags, withStyles(styles))(DollyGrid);
